export default __webpack_public_path__ + "static/media/table-img2.2fed1e3a.svg";